module.exports = __webpack_public_path__ + "img/img-guard-picture-a.269aa9c4.webp";